import lity from 'lity';

export default {
    init() {
        // JavaScript to be fired on the home page

        /**
         * Add show video modal logic
         */
        (() => {
            let videoBtn = document.querySelector(".hp-video-button");

            if (videoBtn) {
                videoBtn.addEventListener("click", function () {
                    const url = $(this).data('url');
                    if (url) {
                        showVideoModal(url);
                    }
                })
            }

            function showVideoModal(url)
            {
                lity(url);
            }
        })();
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js